<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > “向错误学习”平台</div>
        <div style="display: flex;align-items: center;justify-content: flex-end;">
          <el-button class="bt" icon="el-icon-circle-plus-outline" @click="onClickRoute">发布</el-button>
        </div>
        <!--热门板块-->
        <sector :sectorList="sectorList" @onSelectItem="onSelectItem" />
        <!--全部帖子-->
        <div class="forumcenter-box">
          <div class="forumcenter-title">全部帖子</div>
          <forum v-if="forumList.length > 0" :list.sync="forumList" />
          <empty class="empty-margin" v-if="forumList.length <= 0"></empty>
        </div>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";
import forum from '@/views/ForumCenter/components/forum.vue'
import sector from '@/views/ForumCenter/components/sector.vue'
import { getSectionHeat, getForumList } from '@/api/forum'
import empty from "@/components/empty/index";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav, sector, forum, empty },
  data() {
    return {
      selectedIndex: null,
      forumList: [],
      sectorList: [],
      limit: 2,
      rowCount: 0,
      sectionId: '',
    }
  },
  watch: {
  },
  methods: {
    load() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      const clientHeight = document.documentElement.clientHeight
      const scrollHeight = document.documentElement.scrollHeight

      if (scrollTop + clientHeight >= scrollHeight) {
        if(this.limit == this.rowCount) {
          this.getForumList()
        }
      }
    },
    setActive(index) {
      this.activeIndex = index; // 设置当前激活的项
    },
    onSelectItem(value) {
      this.sectionId = value.id
      this.forumList = []

      this.getForumList()
    },
    getSectionHeat() {
      getSectionHeat({
        number: 8,
      }).then(res => {
        this.sectorList = res.data
      })
    },
    getForumList() {
      getForumList({
        skip: this.forumList.length,
        limit: this.limit,
        sectionId: this.sectionId
      }).then(res => {
        this.forumList = [...this.forumList, ...res.data]
        this.rowCount = res.rowCount
      })
    },
    onClickRoute() {
      this.$router.push(`/Publish`)
    }
  },
  mounted() {
    window.addEventListener('scroll', this.load)
    this.getSectionHeat()
    this.getForumList()
  },
  destroyed () {
    // 离开页面取消监听
    window.removeEventListener('scroll', this.load, false)
  }
}
</script>

<style lang="less" scoped>
.bt{
  float: right;
  color: #FFFFFF;
  background: linear-gradient(151.62deg, #EF4034 17.54%, #D82E35 117.32%);
  border: none;
  width: 150px;
  height: 44px;
  font-size: 18px;
}
.forumcenter-box {
  text-align: left;
  padding-bottom: 80px;

  .forumcenter-title {
    font-size: 16px;
    line-height: 16px;
    color: #171717;
    margin: 22px 0;
    font-weight: bold;
  }

  .empty-margin {
    padding: 50px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/ForumCenter/index.vue